export default {
  modelName: 'exit_check_item_template',
  label: '收工檢查項目',
  fields: {
    id: {
      type: 'text',
      label: 'ID',
      readonly: true,
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    is_active: {
      type: 'switch',
      label: '顯示/隱藏',
      defaultValue: true,
      activeText: '顯示',
      inactiveText: '隱藏',
    },
    locales: {
      type: 'locales',
      fields: {
        name: {
          type: 'text',
          label: '收工檢查項目名稱',
          rules: 'required',
          maxlength: 30,
        },
      },
    },
    remark: {
      type: 'text',
      label: '備註（此備註僅顯示於後台註記用，前台不會看到此欄位內容）',
      maxlength: 1000,
    },
    // updated_admin: {
    //   type: 'belongsTo',
    //   label: '最後更新人',
    //   textKey: 'name',
    //   readonly: true,
    // },
    // updated_at: {
    //   type: 'datetime',
    //   label: '更新時間',
    //   readonly: true,
    // },
    name: {
      type: 'text',
      label: '名稱',
      readonly: true,
    },
    area: {
      label: '適用地區',
      type: 'belongsTo',
      textKey: 'name',
      modelName: 'area',
      rules: 'required',
      placeholder: '選擇地區',
      clearable: true,
    },
    area_section: {
      label: '適用子地區',
      type: 'belongsTo',
      textKey: 'name',
      clearable: true,
      modelName: 'area_section',
      placeholder: '選擇子地區',
      requiredField: 'area',
      conditionKeys: [
        {
          fieldName: 'area',
          conditionName: 'area',
        },
      ],
    },
    // system_class: {
    //   label: '選擇領域',
    //   type: 'belongsTo',
    //   textKey: 'name',
    //   modelName: 'system_class',
    //   requiredField: 'area',
    //   conditionKeys: [
    //     {
    //       fieldName: 'area',
    //       conditionName: 'area',
    //     },
    //   ],
    // },
    // system_subclasses: {
    //   conditionKeys: [
    //     {
    //       fieldName: 'system_class',
    //       conditionName: 'system_class',
    //       type: 'array',
    //     },
    //   ],
    //   requiredField: 'system_class',
    //   label: '選擇子領域',
    //   type: 'hasMany',
    //   textKey: 'name',
    //   modelName: 'system_subclass',
    // },
    industry_categories: {
      label: '適用產業別',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'industry_category',
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    updated_info: {
      type: 'custom',
      label: '上次修改時間',
      getValue: (item) => {
        let _value = item.updated_at;
        if (item.updated_admin) {
          _value += `  ${item.updated_admin}`;
        }
        return _value;
      },
    },
  },
};
